import { CreditAlertType } from "../model/creditAlertEnums";
import { CreditAlerts } from "../model/creditAlertModel";
import { CreditAlertsAction } from "./creditAlerts.actions";

export type CreditAlertsState = {
  creditAlerts: CreditAlerts[];
  formData: Partial<CreditAlerts>;
  loading: boolean;
  error: string | null;
  total: number;
  limit: number;
  currentPage: number;
  isCreditAlertDialogOpen: boolean;
  validateErrors: CreditAlertsError;
  toast: {
    isVisible: boolean;
    message: string;
    type: "success" | "error" | "warning" | "info";
  };
  deleteDialogOpen: boolean;
  deletingAalertId: string | null;
};
export const creditAlertsInitialState: CreditAlertsState = {
  creditAlerts: [],
  loading: false,
  error: null,
  total: 0,
  limit: 6,
  currentPage: 1,
  isCreditAlertDialogOpen: false,
  validateErrors: {},
  toast: {
    isVisible: false,
    message: "",
    type: "success",
  },
  formData: {
    alert_type: "",
    threshold_value: 0,
    notification_emails: [],
    notify_admins: false,
  },
  deleteDialogOpen: false,
  deletingAalertId: null,
};
export function creditAlertsReducer(
  state: CreditAlertsState,
  action: CreditAlertsAction,
): CreditAlertsState {
  switch (action.type) {
    case "SET_CREDIT_ALERTS":
      return {
        ...state,
        creditAlerts: action.payload,
      };
    case "SET_LOADING":
      return {
        ...state,
        loading: action.payload,
      };
    case "SET_ERROR":
      return {
        ...state,
        error: action.payload,
      };
    case "SET_TOTAL":
      return {
        ...state,
        total: action.payload,
      };
    case "SET_CURRENT_PAGE":
      return { ...state, currentPage: action.payload };
    case "SET_LIMIT":
      return { ...state, limit: action.payload };
    case "SET_FORM_ERRORS":
      return { ...state, validateErrors: action.payload };
    case "SET_CREDIT_ALERT_DIALOG_OPEN":
      return {
        ...state,
        isCreditAlertDialogOpen: action.payload,
      };
    case "SET_FORM_DATA":
      return {
        ...state,
        formData: { ...state.formData, ...action.payload },
      };
    case "SET_TOAST":
      return {
        ...state,
        toast: action.payload,
      };
    case "SET_DELETE_ALERT_DIALOG_OPEN":
      return {
        ...state,
        deleteDialogOpen: action.payload,
      };
    case "SET_DELETING_ALERT_ID":
      return {
        ...state,
        deletingAalertId: action.payload,
      };
    case "RESET_FORM_DATA":
      return {
        ...state,
        formData: {
          alert_type: CreditAlertType.FIXED_AMOUNT,
          threshold_value: "",
          notify_admins: false,
        },
        validateErrors: {},
      };
    default:
      return state;
  }
}
export interface CreditAlertsError {
  alert_type?: string;
  threshold_value?: string;
  notification_emails?: string;
}
